var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view events"},[_c('div',{staticClass:"events-overview"},[_c('h1',[_vm._v("Alle Events")]),_c('ul',_vm._l((_vm.filteredEvents),function(item,index){return _c('event',{key:index,attrs:{"item":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }